import { defineComponent as r, createBlock as a, openBlock as c, unref as p, mergeProps as i, withCtx as l, createElementVNode as t } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconQuestionMarkInCircle",
  __name: "IconQuestionMarkInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (s, e) => (c(), a(p(m), i(o, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        t("path", { d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0m1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75" }, null, -1),
        t("path", { d: "M12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.75-4c0-1.46 1.152-2.17 1.834-2.624.818-.545 1.166-.836 1.166-1.376 0-.853-.825-1.75-2.25-1.75S9.75 9.147 9.75 10a.75.75 0 0 1-1.5 0c0-1.908 1.743-3.25 3.75-3.25 2.007 0 3.75 1.342 3.75 3.25 0 1.46-1.152 2.17-1.834 2.624C13.098 13.169 12.75 13.46 12.75 14a.75.75 0 0 1-1.5 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
